<div class="image-wrapper">
  <img src="{{ url }}" alt="{{ title }}">
</div>
